import { __awaiter, __generator } from "tslib";
import { app, app as api } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import { getCustomerServiceUrl } from './getCustomerServiceUrl';
export default registerAPI;
export function registerAPI() {
    var _this = this;
    app.on('@vendor:preview:images', function (urls, current) {
        var urls2 = urls.map(function (url) { return (typeof url === 'string' ? url : url.url); });
        var currentUrl = typeof current === 'string' ? current : current.url;
        app.sdk.previewImages(urls2, currentUrl);
    });
    app.on('@vendor:preview:pdf', function (href) {
        app.sdk.preview(href);
    });
    app.on('@vendor:iframepreview:pdf', function (_a) {
        var modalTitle = _a.modalTitle, items = _a.items, currentIdx = _a.currentIdx;
        app.open('@bills:IframePreviewerModal', {
            modalTitle: modalTitle || '附件预览',
            items: items,
            currentIdx: currentIdx
        });
    });
    app.on('@vendor:preview', function (href, fileName) {
        var watermark = api.getState()['@common'].waterMark;
        watermark && watermark !== '' ? app.sdk.preview(href, fileName, { watermark: watermark }) :
            app.sdk.preview(href, fileName);
    });
    app.on('@vendor:preview:byFetch', function (orginUrl, fileName, fileKey) {
        var _a;
        if (((_a = window.PLATFORMINFO) === null || _a === void 0 ? void 0 : _a.oldPreviewService) || !fileKey) {
            api.emit('@vendor:preview', orginUrl, orginUrl);
            return;
        }
        var params = { corpId: Fetch.ekbCorpId, key: fileKey || fileName };
        api.invokeService('@bills:get:preview:wps', params).then(function (result) {
            var _a, _b;
            if ((_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.url) {
                api.sdk.openLink((_b = result.value) === null || _b === void 0 ? void 0 : _b.url);
            }
            else {
                api.emit('@vendor:preview', orginUrl, orginUrl);
            }
        });
    });
    app.on('@vendor:open:link', function (href, needEncode) {
        if (needEncode === void 0) { needEncode = false; }
        app.sdk.openLink(href, { needEncode: needEncode });
    });
    app.on('@vendor:open:link:new', function (href, props) {
        app.sdk.openLink(href, props);
    });
    app.on('@vendor:download', function (href, fileName, showDownloadName) {
        app.sdk.download(href, fileName, showDownloadName);
    });
    app.on('@vendor:goto:ocsa', function (user, channelid) { return __awaiter(_this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getCustomerServiceUrl(user, '7321', channelid)];
                case 1:
                    url = _a.sent();
                    app.sdk.openLink(url);
                    return [2];
            }
        });
    }); });
    app.watch('@vendor:open:layer', function (key, props, isSingle) {
        return app.invoke('@layout:support:open:layer', key, props, isSingle);
    });
    app.watch('@vendor:close:layer', function () {
        return app.invoke('@layout:support:close:layer');
    });
    app.watch('@vendor:dd:message:code', function () {
        return new Promise(function (resolve) { return resolve('debug'); });
    });
    app.watch('@vendor:is:support:authorization', function (args) {
        return true;
    });
    app.on('@vendor:support:select-user', function (args) {
        args.callback && args.callback(false);
    });
    app.on('@vendor:select-user', function (args) {
        app.emit('@layout:support:select-member', args);
    });
    app.on('@vendor:select-multiple-user', function (args) {
        args.multiple = true;
        app.emit('@layout:support:select-member', args);
    });
    app.on('@vendor:select-multiple-user:web', function (args) {
        args.multiple = true;
        app.emit('@layout:support:select-member', args);
    });
    app.watch('@vendor:dingtalk:uploadAttachment', function (params) {
        return app.sdk.invoke('uploadAttachment', params);
    });
    app.watch('@vender:dingtalk:dp:preview', function (params) {
        return app.sdk.invoke('preview', params);
    });
    app.watch('@vendor:dingtalk:space:auth', function (params, callback) {
        if (window.__PLANTFORM__ !== 'DING_TALK') {
            return callback === null || callback === void 0 ? void 0 : callback({ status: 'failed:platform' });
        }
        return app.sdk.invoke('openAuth', params, callback);
    });
}
